import React from 'react';
import Link from 'gatsby-link';
import logo from './logo.svg';
import TopNav from '../TopNav';
import './index.scss'

const Header = () => (
  <div className="header">
    <div className="left-header-spacer" />
    <img className="site-logo" src={logo} width="100" />
    <div className="right-header-spacer" />
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js